<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal terms_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal_close_btn">
        <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
      </div>
      <!-- Modal content-->
      <div mat-dialog-content>
        <!-- Modal-Body -->
        <div class="modal-body">
          <p [innerHtml]="data"></p>
        </div>
      </div>
    </div>
  </div>
</div>
